import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.is-array";

function getNewClassName(newClassName) {
  if (!Array.isArray(newClassName)) return newClassName;
  return newClassName.filter(function (name) {
    return name;
  }).join(" ");
}

export default function appendClassName(baseClassName, newClassName) {
  if (!newClassName) return baseClassName || "";
  if (!baseClassName) return getNewClassName(newClassName) || "";
  return "".concat(baseClassName, " ").concat(getNewClassName(newClassName));
}